import { Category } from ".."

export interface ModifyCategory {
    isDraft: boolean
    isActive: boolean
    isDeleted: boolean
    names: {
        [key: string]: string
    }
    parentId: string
    type: string
}

export class ModifyCategoryFactory {
    static create(): ModifyCategory {
        return {
            isDraft: false,
            isActive: false,
            isDeleted: false,
            names: {},
            parentId: "",
            type: "Award",
        }
    }

    static from(category: Category): ModifyCategory {
        const modifiyCategory: ModifyCategory = JSON.parse(
            JSON.stringify({
                isDraft: category.isDraft,
                isActive: category.isActive,
                isDeleted: category.isDeleted,
                names: category.names,
                parentId: category.parentId,
                type: category.type,
            })
        )
        return modifiyCategory
    }
}
